(() => {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer || !drawer.showModal) return;
  const message = drawer.querySelector('[data-cart-message]');
  const undoBar = drawer.querySelector('[data-cart-undo]');
  const root = window.Shopify?.routes?.root || '/';
  let busy = false, previousFocus, removedItem = null, dirty = false, closeTimer;
  const content = () => drawer.querySelector('[data-cart-content]');
  const label = name => content()?.dataset[name] || '';
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  function open() {
    clearTimeout(closeTimer); drawer.classList.remove('is-closing');
    if (!drawer.open) { previousFocus = document.activeElement; drawer.showModal(); document.documentElement.classList.add('cart-is-open'); }
  }
  function close() {
    if (!drawer.open) return;
    drawer.classList.add('is-closing');
    closeTimer = setTimeout(() => drawer.close(), reduced() ? 0 : 220);
  }
  drawer.addEventListener('close', () => {
    document.documentElement.classList.remove('cart-is-open'); drawer.classList.remove('is-closing'); previousFocus?.focus();
    if (dirty && location.pathname.replace(/\/$/, '') === drawer.dataset.cartUrl.replace(/\/$/, '')) location.reload();
  });
  drawer.addEventListener('cancel', event => { event.preventDefault(); close(); });
  drawer.addEventListener('click', event => { if (event.target === drawer) { const r = drawer.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right) close(); } });
  function render(html) {
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-content]');
    if (!next) throw new Error(label('error'));
    const oldCount = document.querySelector('.cart-link span')?.textContent;
    content().replaceWith(next);
    document.querySelectorAll('.cart-link span').forEach(badge => {
      badge.textContent = next.dataset.cartCount;
      if (oldCount !== badge.textContent && !reduced()) badge.animate([{transform:'scale(1)'},{transform:'scale(1.3)'},{transform:'scale(1)'}],{duration:350});
    });
    if (!reduced()) next.animate([{opacity:.55,transform:'translateY(5px)'},{opacity:1,transform:'none'}],{duration:200});
  }
  async function request(url, options = {}) {
    const response = await fetch(url, {...options, headers: {Accept:'application/json', ...options.headers}});
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : label('error'));
    return data;
  }
  async function refresh() {
    const data = await request(root + '?sections=cart-panel');
    if (!data['cart-panel']) throw new Error(label('error'));
    render(data['cart-panel']);
  }
  async function update(action, payload, success) {
    if (busy) return;
    busy = true; open(); message.textContent = label('loading'); drawer.setAttribute('aria-busy','true'); drawer.classList.add('is-loading');
    try {
      let body, headers = {};
      if (payload instanceof FormData) {
        payload.set('sections','cart-panel'); payload.set('sections_url',root); body = payload;
      } else { body=JSON.stringify({...payload,sections:'cart-panel',sections_url:root}); headers['Content-Type']='application/json'; }
      const data = await request(root+'cart/'+action+'.js', {method:'POST',body,headers});
      dirty = true;
      if (data.sections?.['cart-panel']) render(data.sections['cart-panel']); else await refresh();
      success?.(); message.textContent = label('updated'); drawer.querySelector('[data-cart-close]').focus();
    } catch (error) { message.textContent = error.message || label('error'); }
    finally { busy = false; drawer.removeAttribute('aria-busy'); drawer.classList.remove('is-loading'); }
  }
  document.addEventListener('click', event => {
    const target = event.target.closest('a,button'); if (!target) return;
    if (target.matches('.cart-link') && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
      event.preventDefault(); open();
      if (!busy) { busy=true; drawer.classList.add('is-loading'); refresh().catch(error=>message.textContent=error.message).finally(()=>{busy=false;drawer.classList.remove('is-loading');}); }
    }
    if (target.matches('[data-cart-close]')) close();
    if (!drawer.contains(target) || busy) return;
    if (target.matches('[data-quantity]')) update('change',{id:target.dataset.key,quantity:Number(target.dataset.quantity)});
    if (target.matches('[data-remove]')) {
      const restore={id:Number(target.dataset.variant),quantity:Number(target.dataset.count),properties:JSON.parse(target.dataset.properties || '{}')};
      if (target.dataset.plan) restore.selling_plan=Number(target.dataset.plan);
      update('change',{id:target.dataset.key,quantity:0},()=>{removedItem=restore;undoBar.hidden=false;});
    }
    if (target.matches('[data-undo]') && removedItem) update('add',{items:[removedItem]},()=>{removedItem=null;undoBar.hidden=true;});
  });
  document.addEventListener('submit', event => {
    const form=event.target;
    if (busy && drawer.contains(form)) { event.preventDefault(); return; }
    if (!form.matches('form') || !event.submitter?.matches('[data-add]')) return;
    if (form.querySelector('input[type="file"]')?.files?.length) return;
    event.preventDefault(); if (busy) return;
    update('add',new FormData(form));
  });
})();
